import React, { useState } from 'react';
import { Image, Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Gallery() {
  const [images, setImages] = useState([
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1551972873-b7e8754e8e26',
      title: 'Carnevale',
      category: 'Eventi'
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1563841930606-67e2bce48b78',
      title: 'Estate in Festa',
      category: 'Eventi'
    }
  ]);

  const handleDelete = (id: number) => {
    if (window.confirm('Sei sicuro di voler eliminare questa immagine?')) {
      setImages(images.filter(image => image.id !== id));
      toast.success('Immagine eliminata con successo');
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-900">Gestione Galleria</h2>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
          <Plus className="h-4 w-4 mr-2" />
          Aggiungi Immagine
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {images.map((image) => (
          <div
            key={image.id}
            className="relative group bg-white rounded-lg shadow-sm overflow-hidden"
          >
            <div className="aspect-w-3 aspect-h-2">
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-opacity duration-300">
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button
                    onClick={() => handleDelete(image.id)}
                    className="p-2 bg-red-600 rounded-full text-white hover:bg-red-700 focus:outline-none"
                  >
                    <Trash2 className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-gray-900">{image.title}</h3>
              <p className="text-sm text-gray-500">{image.category}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}